import { render, staticRenderFns } from "./MenuCategoryModal.vue?vue&type=template&id=0573abcf&scoped=true"
import script from "./MenuCategoryModal.vue?vue&type=script&lang=ts"
export * from "./MenuCategoryModal.vue?vue&type=script&lang=ts"
import style0 from "./MenuCategoryModal.vue?vue&type=style&index=0&id=0573abcf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0573abcf",
  null
  
)

export default component.exports